import { Link, useLocation } from 'react-router-dom'
import { HiChevronRight, HiHome } from 'react-icons/hi'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

/**
 * Composant Breadcrumbs pour la navigation fil d'Ariane
 * Génère automatiquement les miettes à partir de l'URL
 */
const Breadcrumbs = ({ className }) => {
  const { t } = useTranslation()
  const location = useLocation()

  // Générer les breadcrumbs à partir du path
  const generateBreadcrumbs = () => {
    const paths = location.pathname.split('/').filter(Boolean)
    const breadcrumbs = [
      {
        label: t('nav.home'),
        path: '/',
        icon: HiHome,
      },
    ]

    let currentPath = ''
    paths.forEach((path, index) => {
      currentPath += `/${path}`
      
      // Ne pas ajouter les IDs (UUIDs ou nombres)
      if (path.match(/^[a-f0-9-]{36}$/i) || path === 'edit' || path === 'new') {
        return
      }

      breadcrumbs.push({
        label: t(`nav.${path}`, path), // Fallback au path si traduction manquante
        path: currentPath,
      })
    })

    return breadcrumbs
  }

  const breadcrumbs = generateBreadcrumbs()

  if (breadcrumbs.length <= 1) {
    return null // Ne rien afficher si on est à la racine
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={classNames('flex items-center space-x-2 text-sm', className)}
    >
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        const Icon = crumb.icon

        return (
          <div key={crumb.path} className="flex items-center">
            {index > 0 && (
              <HiChevronRight className="mx-2 w-4 h-4 text-gray-400 dark:text-gray-600" />
            )}
            
            {isLast ? (
              <span className="flex items-center gap-1.5 text-gray-900 dark:text-gray-100 font-medium">
                {Icon && <Icon className="w-4 h-4" />}
                {crumb.label}
              </span>
            ) : (
              <Link
                to={crumb.path}
                className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >
                {Icon && <Icon className="w-4 h-4" />}
                {crumb.label}
              </Link>
            )}
          </div>
        )
      })}
    </nav>
  )
}

export default Breadcrumbs




